export const passwordRegex = /^(?=.*[A-Za-z])(?=.*d)[A-Za-zd]{6}$/
export const phoneRegex = /^\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/
